import { createFileRoute, notFound } from "@tanstack/react-router";
import { useState } from "react";
import { PseoPage } from "@/components/laneguide/PseoPage";
import { getCategory, PSEO_LENDERS, formatKr } from "@/lib/pseo";
import { amountsForCategory, getMatrixCategory } from "@/lib/pseo-matrix";

const BASE = "https://svensklaneguide.se";

export const Route = createFileRoute("/kategori/$slug")({
  loader: ({ params }) => {
    const cat = getCategory(params.slug);
    if (!cat) throw notFound();
    return { slug: cat.slug };
  },
  head: ({ params, loaderData }) => {
    const cat = loaderData ? getCategory(loaderData.slug) : null;
    if (!cat) {
      return { meta: [{ title: "Sidan hittades inte" }, { name: "robots", content: "noindex" }] };
    }
    const url = `${BASE}/kategori/${params.slug}`;
    return {
      meta: [
        { title: `${cat.title} | Svensk Låneguide` },
        { name: "description", content: cat.description },
        { property: "og:title", content: cat.title },
        { property: "og:description", content: cat.description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "robots", content: "index, follow" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: CategoryPage,
});

function CategoryPage() {
  const { slug } = Route.useLoaderData();
  const cat = getCategory(slug)!;
  const [amount, setAmount] = useState(cat.defaultAmount);
  const lenders = PSEO_LENDERS.filter(
    (l) => cat.filter(l) && l.minAmount <= amount && l.maxAmount >= amount,
  ).sort((a, b) => b.rating - a.rating || a.minInterest - b.minInterest);

  const matrix = getMatrixCategory(slug);
  const related = matrix
    ? amountsForCategory(matrix).map((a) => ({
        label: `${matrix.crumb} ${formatKr(a)}`,
        to: `/${matrix.slug}/${a}-kr`,
      }))
    : [];

  return (
    <PseoPage
      h1={cat.h1}
      intro={cat.intro}
      amount={amount}
      onAmountChange={setAmount}
      amountEditable
      lenders={lenders}
      crumbs={[{ label: "Hem", to: "/" }, { label: cat.h1.split(" –")[0]! }]}
      epi={`pseo-kategori-${slug}`}
      relatedTitle="Populära lånebelopp"
      related={related}
    />
  );
}


